export default __webpack_public_path__ + "static/media/callus.94213400.svg";